import GenericModel from '@/shared/models/generic-model';
import i18n from '@/shared/plugins/vue-i18n';
import StringField from '@/shared/fields/string-field';
import EnumField from '@/shared/fields/enum-field';
import IdField from '@/shared/fields/id-field';

const label = (name) => i18n.t(`FORMS.FIELDS.${name.toUpperCase()}`);
const enumLabel = (name, value) => i18n.t(`FORMS.ENUMS.${name.toUpperCase()}.${value.toUpperCase()}`);
const placeholder = (name) => i18n.t(`FORMS.PLACEHOLDERS.${name.toUpperCase()}`);

const fields = {
    id: new IdField('id', 'Id'),
    name: new StringField('name', label('name'), {
        required: true,
    }, { placeholder: placeholder('name') }),
    description: new StringField('description', label('description'), {
        required: true,
    }),
    status: new EnumField('status', label('status'), [
        { value: 'draft', text: enumLabel('status', 'draft') },
        { value: 'published', text: enumLabel('status', 'published') },
    ], {
        required: true
    }, { placeholder: placeholder('status') }),
};

export class FormsModel extends GenericModel {
    static get fields() {
        return fields;
    }
}
